export const custom = {
  /**
  * Idiomas disponibles ['es','en','pt','cat']
  */
  availableLangs: ['es'],

  /**
   * Idioma por defecto: ['es']
   */
  defaultLang: 'es',

  /**
   * Versión de la API: v2|v3
   */
  apiVersion: 'v3',

  /**
   * API key de conexión a la api definida en cada entorno
   * (debe ser el mismo en todos los servicios)
   */
  apiKey: '1ffdbc5d-4677-4a43-979a-329a884f710e',

  /**
   * URL de la app
   *
   * subdominio.dominio
   */
  appUrlDomain: 'manpowergroup.alares',

  /**
  * Nombre de la app
  */
  appName: 'Plan 4U',

  /**
  * Código de analytics 'G-XXXXXXXXXXX'
  * (Activado en pro, desactivado en pre y local)
  */
  analyticsId: 'G-Q7ZMWE18E9',

  /** true o false. Define si es necesario hacer login para acceder a los contenidos */
  protected: true,

  /** Registro habilitado o deshabilitado */
  registration: false,

  /** true o false. Define si los formularios son para conciliación o no */
  conciliation: true,
  
    
  /**
   * Extensión en producción de URL de la app
   * (es, com, org...)
   */
   appUrlTld: 'es',

  /**
   * Nombre de marca interno (Alares, Vivofácil...)
   */
   brandName: 'Alares',
   
   /**
   * Mail transport (alares, vivofacil...)
   */
   mailTransport: 'alares'
};
